import { gql } from '@apollo/client'

export const Query = gql`
  query PortfolioPages($companyId: ID!, $filters: PortfolioPageFilters, $order: PortfolioPageOrder, $after: String, $before: String, $first: Int, $last: Int) {
    portfolioPages(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        slug
        title
        description
        enabled
        publicLink
        event {
          id
          description
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
